import type { UseQueryResult } from '@tanstack/react-query';

import {
  PrivateEventHistoryForbiddenError,
  type PrivateEventHistoryEntry,
} from '../../api/private-event-history';

const NOTE = { padding: '8px 16px 14px', margin: 0, fontSize: 12, color: 'var(--nb-subtle)' };

/** What stands in for the list while it loads, when the viewer may not read it,
 *  and when it fails. A 403 is expected for some viewers, so it is a quiet note
 *  rather than an alert. */
export default function HistoryStatus({
  history,
}: {
  history: UseQueryResult<PrivateEventHistoryEntry[]>;
}) {
  if (history.isPending) {
    return (
      <p role="status" style={NOTE}>
        Loading history…
      </p>
    );
  }
  if (!history.isError) return null;
  if (history.error instanceof PrivateEventHistoryForbiddenError) {
    return <p style={NOTE}>You don’t have access to the change history.</p>;
  }
  return (
    <p role="status" style={{ ...NOTE, color: 'var(--nb-risk)' }}>
      We couldn’t load the change history.{' '}
      <button
        type="button"
        onClick={() => void history.refetch()}
        style={{ color: 'var(--nb-primary)', fontWeight: 700, textDecoration: 'underline' }}
      >
        Retry
      </button>
    </p>
  );
}
